import styled from 'styled-components';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { PSmall } from '../elements/Text';

dayjs.extend(utc);
dayjs.extend(timezone);

const AnnouncementWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.textActive};
  border-radius: 8px;
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
`;

const CalendarIcon = styled.i.attrs({
  className: 'fa-solid fa-calendar-days',
})`
  color: ${({ theme }) => theme.colors.buttonTextColor};
  font-size: 16px;
  margin: 0;
  padding: 0;
`;

const AnnouncementText = styled(PSmall)`
  color: ${({ theme }) => theme.colors.buttonTextColor};
  margin: 0;
  padding: 0;
  font-weight: 600;
`;
export default function AnnouncementBanner({
  kickOffTime,
}: {
  kickOffTime: string;
}) {
  const learnerTimezone = dayjs.tz.guess();
  const kickOffTimeInLearnerTimezone = dayjs
    .tz(kickOffTime, 'UTC')
    .tz(learnerTimezone);
  return (
    <AnnouncementWrapper>
      <CalendarIcon />
      <AnnouncementText>
        The Cohort kick-off call will happen on{' '}
        {kickOffTimeInLearnerTimezone.format('dddd MMMM D')}, at{' '}
        {kickOffTimeInLearnerTimezone.format('h a (z)')}. See you then!
      </AnnouncementText>
    </AnnouncementWrapper>
  );
}
